import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogContent, Grid, Typography } from '@mui/material';
import { SaveModalProps, saveModalStyles } from './save-modal-helper';

export const SaveModal = ({
    openSaveModal,
    saveHeadingText,
    saveSubHeadingText,
    saveButtonText,
    handleSaveClick,
    cancelButtonText,
    handleCancelClick,
    customStyles,
    children,
}: SaveModalProps): React.JSX.Element => {
    return (
        <Dialog
            closable={true}
            open={openSaveModal}
            onClose={handleCancelClick}
            title={saveHeadingText}
            sx={{
                ...saveModalStyles.dialogStyles,
                ...(customStyles && { ...customStyles }),
            }}
        >
            <DialogContent>
                <Grid>
                    <Typography>{saveSubHeadingText}</Typography>
                </Grid>
                <Grid>{children}</Grid>
                <Grid sx={saveModalStyles.buttonContainer}>
                    <Button
                        size='large'
                        color='primary'
                        onClick={handleSaveClick}
                    >
                        {saveButtonText}
                    </Button>
                    <Button
                        size='large'
                        variant='text'
                        onClick={handleCancelClick}
                    >
                        {cancelButtonText}
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
